/* eslint-disable import/prefer-default-export, camelcase */

export const convertStatus = (serverStatus: string): 'inProgress' | 'completed' | 'notStarted' => {
    switch (serverStatus) {
        case 'started':
            return 'inProgress';
        case 'completed':
            return 'completed';
        case 'not_started':
            return 'notStarted';
        default:
            return 'notStarted';
    }
};

export const progressOrder = ['inProgress', 'notStarted', 'completed'];

export const convertNumber = (num: number): string => {
    if (num >= 1000) {
        const roundedNumber = Math.floor(num / 100) / 10;
        return `${roundedNumber}K`;
    }
    return num.toString();
};

export const convertTimeFormat = (mins: number): string => {
    const hours = Math.floor(mins / 60);
    const remainingMinutes = mins % 60;
    return `${hours}:${remainingMinutes}`;
};

export const formatFullTime = (mins: number): string => {
    const hours = Math.floor(mins / 60);
    const remainingMinutes = mins % 60;
    return `${hours}h:${remainingMinutes}min`;
};
